import React, { useState, useEffect, useRef } from 'react';
import { Button, Container, Row, Col, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { referralActions } from '../../actions';
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next';

import PageTitle from "../../components/common/PageTitle";
import date from '../../utils/date'

const ReferralsList = () => {
    const { SearchBar } = Search;
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    // const user = useSelector(state => state.authentication.user);
    const loading = useSelector(state => state.referral.status);
    const referrals = useSelector(state => state.referral.referralList);
    const [show, setShow] = useState(false);


    useEffect(() => {
        dispatch(referralActions.getAllReferrals());
    }, [])

    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => {
        setShow(true);
    }

    const formik = useFormik({
        initialValues: {
            name: ''
        },
        onSubmit: values => {
            setShow(false);
            dispatch(
                referralActions.createReferral({
                    name: values.name,
                }),
            );
            formik.values.name = '';
        },

    });

    const columns = [
        {
            text: 'Name',
            dataField: 'name',
        },
        {
            text: 'Total Codes',
            dataField: 'codes',
            formatter: codesFormatter,
        },
        {
            text: 'Total Used',
            dataField: 'codesUsed',
            formatter: usedFormatter,
        },
        {
            text: 'Create at',
            dataField: 'createdAt',
            formatter: dateFormatter,
        },
        {
            text: 'Action',
            dataField: '_id',
            formatter: actionFormatter,
        }
    ]

    function codesFormatter(cell, row) {
        return cell.length;
    }
    function usedFormatter(cell, row) {
        let used = 0;
        row.codes.map(use => {
            used += use.timesUsed
        })
        return used;
    }
    function dateFormatter(cell, row) {
        return date(cell)
    }
    function actionFormatter(cell, row) {
        return (
            <div className="tableTempActionBox">
                <Button className="tableTempAction" theme="info" onClick={() => detailsHandler(cell)}><i className="material-icons">info</i> Details</Button>
                {/* <Button className="tableTempAction" onClick={() => editHandler(cell)}><i className="material-icons">edit</i> Edit</Button>
                <Button className="tableTempAction" theme="danger"><i className="material-icons">delete</i> Delete</Button> */}
            </div>
        )
    }

    const detailsHandler = (referralId) => {
        history.push(`referral/${referralId}`);
    }

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Showing { from} to { to} of { size} Results
        </span>
    );

    const options = {
        paginationTotalRenderer: customTotal,
        showTotal: true,
        onSizePerPageChange: (sizePerPage, page) => {
            // console.log('Size per page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        },
        onPageChange: (page, sizePerPage) => {
            // console.log('Page change!!!');
            // console.log('Newest size per page:' + sizePerPage);
            // console.log('Newest page:' + page);
        }
    };

    return (
        <Container fluid className={`main-content-container px-4 ${loading === 'loading' && 'blur'}`}>
            {/* Page Header */}
            <Row noGutters className="page-header py-4">
                <PageTitle sm="4" title="Referrals" subtitle="Accounting" className="text-sm-left" />
                <Col className="headerButtonHolder">
                    <Button variant="success" onClick={handleShow}><i className="material-icons"></i> New</Button>
                    {/* <Button className="" variant="danger" onClick={() => history.push(`/referrals`)}><i className="material-icons"></i> Back</Button> */}
                </Col>
            </Row>
            <Row>
                <Col>
                    <ToolkitProvider
                        keyField="_id"
                        data={referrals}
                        columns={columns}
                        search
                    >
                        {
                            props => (
                                <div>
                                    <SearchBar {...props.searchProps} />
                                    <hr />
                                    <BootstrapTable
                                        {...props.baseProps}
                                        pagination={paginationFactory(options)}
                                    />
                                </div>
                            )
                        }
                    </ToolkitProvider>
                </Col>
            </Row>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>New Referral</Modal.Title>
                </Modal.Header>
                <form id="form" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <span>Name:</span>
                                <input id="name" name="name" value={formik.values.name} onChange={formik.handleChange} />
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={handleClose}>
                            Cancel
          </Button>
                        <Button type="submit" variant="primary">
                            Create
          </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </Container>
    );
}

export default ReferralsList;
